import { gql } from '@apollo/client';
import {
  CORE_PROJECT_TYPE_FIELDS,
  CORE_FACULTY_FIELDS,
  CORE_PROJECT_CATEGORY_FIELDS,
} from './fragments';

export const GET_BUDGETS = gql`
  query GET_BUDGETS($ids: [ID!], $projectIds: [ID!]) {
    budgets(ids: $ids, projectIds: $projectIds) {
      id
      approvedFunding
      additionalFunding
      remarks
      balance
      budgetCategory {
        id
        name
        seq
      }
    }
  }
`;

export const GET_BUDGET = gql`
  query GET_BUDGET(
    $ids: [ID!]
    $projectIds: [ID!]
    $virementStatus: [ApplicationStatus!]
  ) {
    budgets(ids: $ids, projectIds: $projectIds) {
      id
      approvedFunding
      additionalFunding
      remarks
      balance
      budgetCategory {
        id
        name
      }
      virements(status: $virementStatus) {
        id
        date
        fromBudget {
          id
          budgetCategory {
            id
            name
          }
        }
        toBudget {
          id
          budgetCategory {
            id
            name
          }
        }
        amount
        status
      }
    }
  }
`;

export const GET_BUDGETS_PROJECT_INFO = gql`
  ${CORE_PROJECT_TYPE_FIELDS}
  ${CORE_FACULTY_FIELDS}
  ${CORE_PROJECT_CATEGORY_FIELDS}
  query GET_BUDGETS_PROJECT_INFO(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: Status
  ) {
    budgets(ids: $ids, projectIds: $projectIds) {
      id
      approvedFunding
      additionalFunding
      remarks
      budgetCategory {
        id
        name
      }
    }
    projects(ids: $projectIds, status: $status) {
      nodes {
        id
        title
        projectCategory {
          id
          name
        }
        projectStatus {
          id
          name
        }
        projectBudget {
          approvedFunding
          additionalFunding
          total
        }
        profile {
          projectType {
            id
            name
          }
          projectCode
          department {
            id
            name
            faculty {
              id
              name
            }
          }
          accountCode
          accountSetUpDate
          accountClosedDate
          workProgramme
          originalStartDate
          originalCompletionDate
          actualStartDate
          actualCompletionDate
          deadlineOfUsingUpFunding
          lastApprovedCompletionDate
          totalFunding
          totalAdditionalFunding
          approvedFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          additionalFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          proposal {
            id
            filename
          }
          supplements {
            id
            filename
          }
          historyLog
          historyLogByPMS
        }
      }
    }
    projectCategories {
      ...CoreProjectCategoryFields
    }
    faculties {
      ...CoreFacultyFields
    }
    projectTypes {
      ...CoreProjectTypeFields
    }
  }
`;

export const ADD_BUDGET = gql`
  mutation ADD_BUDGET($input: AddBudgetInput!) {
    addBudget(input: $input) {
      id
      budgetCategory {
        name
      }
    }
  }
`;

export const UPDATE_BUDGET = gql`
  mutation UPDATE_BUDGET($input: UpdateBudgetInput!) {
    updateBudget(input: $input) {
      id
      budgetCategory {
        name
      }
    }
  }
`;

export const DELETE_BUDGET = gql`
  mutation DELETE_BUDGET($input: DeleteBudgetInput!) {
    deleteBudget(input: $input)
  }
`;
